import fetch from '../../../utils/fetch';
import {VISION_LIST_RESET, VISION_LIST_SUCCESS,} from './mutation-types';
import {STATS_VISION} from '../../../constants/api-routes';


const getDefaultState = () => {
    return {
        visions: []
    };
};
const state = getDefaultState();

function success(data) {
    return {type: VISION_LIST_SUCCESS, data};
}

function reset() {
    return {type: VISION_LIST_RESET};
}

const getters = {
    visions: state => state.visions
};

const actions = {
    getList({commit}, contactId) {
        let url = STATS_VISION;
        if (contactId) {
            url += '/' + contactId;
        }
        return fetch(url)
            .then(data => {
                if (data) {
                    commit(success(data));
                }
            });
    },
    reset({commit}) {
        commit(reset());
    }
};

const mutations = {
    [VISION_LIST_SUCCESS](state, {data}) {
        state.visions = data;
    },
    [VISION_LIST_RESET](state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/vision/list.js